export default "__VITE_ASSET__CJ86vyKO__"